import { createContext, useContext, type CSSProperties, type HTMLAttributes, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

/**
 * Panneau plein écran (fiche, visualiseur, appareil photo, visionneuse) rendu
 * directement dans <body>, hors de la zone qui défile (.corps).
 *
 * Pourquoi : sur iPhone (Safari), un élément « position: fixed » placé dans une
 * zone qui défile reste pris dans cette zone. La barre d'onglets du chantier
 * passait alors par-dessus les boutons Annuler / Créer de la fiche (3 nov. 2026).
 *
 * Un panneau ouvert depuis un autre panneau (ex. fiche de suivi depuis le plan)
 * passe toujours devant lui : le z-index monte de 100 à chaque niveau.
 */
const Profondeur = createContext(0)

const BASE: Record<string, number> = { feuille: 40, camera: 50, visionneuse: 60 }

export function Superpose({
  className = 'feuille',
  style,
  children,
  ...reste
}: { className?: string; style?: CSSProperties; children: ReactNode } & Omit<HTMLAttributes<HTMLDivElement>, 'className' | 'style' | 'children'>) {
  const niveau = useContext(Profondeur)
  const base = BASE[className.split(' ')[0]] ?? 40
  return createPortal(
    <Profondeur.Provider value={niveau + 1}>
      <div className={className} style={{ ...style, zIndex: base + niveau * 100 }} {...reste}>
        {children}
      </div>
    </Profondeur.Provider>,
    document.body
  )
}
